"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MypageUpcomingReservationWidgetDataSchema = void 0;
var zod_1 = require("zod");
var MypageUpcomingReservationGroupItemSchema = zod_1.z.object({
    amount: zod_1.z.string().optional(),
    attribute: zod_1.z.string().optional().nullable(),
    datetime: zod_1.z.object({
        date: zod_1.z.string(),
        prefix: zod_1.z.string().nullable(),
        time: zod_1.z.string().nullable(),
    }),
    id: zod_1.z.string().optional(),
    image: zod_1.z.object({ url: zod_1.z.string() }),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).optional().nullable(),
    option: zod_1.z
        .object({
        title: zod_1.z.string(),
        /** 옵션 그룹명 */
        groupTitle: zod_1.z.string(),
    })
        .nullable()
        .optional(),
    title: zod_1.z.string(),
    action: zod_1.z.object({
        app: zod_1.z.string(),
        web: zod_1.z.string(),
    }),
});
var MypageUpcomingReservationGroupSchema = zod_1.z.object({
    /** 예약 상품의 타입 */
    type: zod_1.z.enum(['LOCAL_PROPERTY', 'GLOBAL_PROPERTY', 'VOUCHER', 'LEISURE', 'TRANSPORTATION', 'FLIGHT']),
    /** 왕복 여부 - 교통/항공에만 존재하는 특성 */
    isRoundTrip: zod_1.z.boolean().optional(),
    /**
     * 왕복일 때 화살표 버튼을 하나로 표시할지 여부
     * 국제선 항공 및 KTX/고속버스 왕복 케이스에 가는편과 오는편 둘의 링크가 같음
     */
    isSingleButton: zod_1.z.boolean().optional(),
    /** 안내 - 항공(국제선)에만 존재하는 속성 */
    memo: zod_1.z
        .object({
        content: zod_1.z.string(),
        title: zod_1.z.string(),
    })
        .nullable()
        .optional(),
    /** 예약 상품 리스트 */
    items: zod_1.z.array(MypageUpcomingReservationGroupItemSchema),
});
exports.MypageUpcomingReservationWidgetDataSchema = zod_1.z.object({
    header: zod_1.z.object({
        /**
         * 타이틀
         * @example 다가오는 예약이 있어요!
         */
        title: zod_1.z.string(),
    }),
    footer: zod_1.z.object({
        /**
         * Footer 문구
         * @example 더 많은 예약 정보는 예약 내역에서 확인해주세요
         */
        title: zod_1.z.string().nullable(),
    }),
    items: zod_1.z.array(MypageUpcomingReservationGroupSchema),
});
